import styled   from 'styled-components'
import SSButton from 'ui/shell/SSButton'
import { prop } from 'styled-tools'

const SubmitButton = styled(SSButton)`
  height: 40px;
  padding: 0.6rem 1.5rem !important;
  width: ${prop('width', '100%')};
  display: inline-flex;
  justify-content: center;
  align-items: center;
`

export default SubmitButton
